import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/admin.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteDailogComponent } from '../delete-dailog/delete-dailog.component';

@Component({
  selector: 'app-settings',
  templateUrl: './advatages.component.html',
  styleUrls: ['./advatages.component.css']
})
export class AdvatageComponent implements OnInit {
  category:Array<any> =[];
  catText:string = "";
  userID:string ;
  projectID:string ;
  price:string ;
  deviceType:Array<any> =[];
  couponAmount: string = "";
  baseUrl:string;
  previewUrl:any;
  isFileUploaded:boolean = false;
  catForm:FormGroup;
  prizeForm:FormGroup;
  id:string = "";
  constructor(private adminService:AdminService,  private cd: ChangeDetectorRef, private fb:FormBuilder,
    private snackBar:MatSnackBar, private dialog:MatDialog) { }

  ngOnInit() {
    this.previewUrl ="../../../assets/Add_image.png";
    this.baseUrl = this.adminService.baseUrl;
    this.browseCategory();
    this.catForm = this.fb.group({
      categoryName:["",Validators.required],
      userID:[""],
      price:[""],
      deviceType:[""],
      projectID:[""],
      image:["",Validators.required]
    })
  }
  //message alerts showing
openSnackBar(message: string, action: string) {
  this.snackBar.open(message, action, {
    duration: 3000
  });
}
// Browse Category
browseCategory(){
  this.adminService.browseCategory().subscribe((posRes)=>{
    if(posRes.response == 3){
      this.category = posRes.AdvertisementsList;
      
    }else{
      this.openSnackBar(posRes.message,"")
    }
  },(err:HttpErrorResponse)=>{
    if(err.error instanceof Error){
      console.warn("CSE",err.message);
    }else{
      console.warn("SSE",err.message);
      
    }
  })
}
Advatagedata(){
  let random ="Cat" + new Date().getTime();
  let text = this.catForm.value.categoryName;
  // let text2 = this.catForm.value.projectID;
  // let text3 = this.catForm.value.userID;
  // let text4 = this.catForm.value.price;
  // let text5 = this.catForm.value.deviceType;
  if(text != ""){
    let index = this.category.findIndex(val=>{
      let cat = val.categoryName.toLowerCase();
      return cat == text.toLowerCase()
    })
    if(index < 0){
      
      this.adminService.showLoader.next(true);
      let formData = new FormData();
      formData.append("categoryName",text);
      formData.append("projectID",this.catForm.value.projectID);
      formData.append("userID",this.catForm.value.userID);
      formData.append("price",this.catForm.value.price);
      formData.append("deviceType",this.deviceType[0]);
      formData.append("image",this.catForm.value.image);  
     // // console.log("ccc",formData.append("deviceType",this.catForm.value.deviceType));
      let token = sessionStorage.getItem('token')
      this.adminService.advatageInsert(formData,token).subscribe((posRes)=>{
        this.adminService.showLoader.next(false);
        if(posRes.response == 3){
          this.openSnackBar(posRes.message,"");
          this.previewUrl ="../../../assets/Add_image.png";
          this.browseCategory();
          this.catForm.patchValue({
            categoryName: "",
            projectID: "",
            userID: "",
            price: "",
            deviceType: "",
            image : null
          })
        }else{
          this.catForm.patchValue({
            categoryName: "",
            projectID: "",
            userID: "",
            deviceType: "",
            price: "",
            image : null
          })
          this.openSnackBar(posRes.message,"");
        }
      },(err:HttpErrorResponse)=>{
        this.adminService.showLoader.next(false);
        this.openSnackBar(err.message,"");
        if(err.error instanceof Error){
          console.warn("Client Side Error", err.message);
        }else{
          console.warn("Server Error", err.message)
        }
      })
    }else{
      alert("Duplicates are not allowed..");
    }
  }

 
}
 //File Upload
 fileProgress(event) {
  let reader = new FileReader(); // HTML5 FileReader API
  let file = event.target.files[0];
  // console.log("FIle",file);
  if (event.target.files && event.target.files[0]) {
    reader.readAsDataURL(file);
    // When file uploads set it to file formcontrol
    reader.onload = () => {
      this.previewUrl = reader.result;
      
      this.catForm.get('image').setValue(file);
      this.isFileUploaded = true;
    }
    // ChangeDetectorRef since file is loading outside the zone
    this.cd.markForCheck();
  }
}
deleteCat(data,i){ 
  let message = `Do you want to delete ${data.categoryName} category.` 
  let dailogRef = this.dialog.open(DeleteDailogComponent, {
    panelClass: 'col-md-4',
    hasBackdrop: true,
    disableClose:true,
    data : message
  })
  dailogRef.afterClosed().subscribe(res=>{
    if(res){
      this.adminService.showLoader.next(true);
      let obj = {
        categoryId : data.categoryId
      };
      let token = sessionStorage.getItem('token');
      this.adminService.deleteAdvatage(obj,token).subscribe((posRes)=>{
        this.adminService.showLoader.next(false);
        this.openSnackBar(posRes.message,"");
        this.category.splice(i,1)
      },(err:HttpErrorResponse)=>{
        this.adminService.showLoader.next(false);
        this.openSnackBar(err.message,"")
        if(err.error instanceof Error){
          console.warn("Client Error",err.error);
        }else{
          console.warn("Server Error",err.error);
        }
      })
    }
  })
}
}